var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 6 5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.528 2.581c.001-.12.098-.217.218-.217h2.9c.076 0 .137-.061.137-.137v-1.485c0-.022.018-.04.04-.04h.99c.086 0 .164.05.199.129l.487.906c.001.001.001.002.002.003.012.029.019.059.019.089l-.012 1.73c-.002.121-.099.218-.219.218h-.032c-.022 0-.041-.019-.041-.041 0-.406-.327-.735-.73-.735s-.731.329-.731.735c0 .022-.018.041-.041.041h-.227c-.023 0-.041-.019-.041-.041 0-.406-.327-.735-.731-.735-.262 0-.492.14-.62.348-.016.025-.053.026-.069 0-.13-.201-.356-.334-.613-.334-.403 0-.73.329-.73.734 0 .007 0 .012.001.018-.095-.029-.164-.118-.163-.223l.007-.963zm3.503-.823c0 .037.027.067.061.067l1.042.004c.035 0 .062-.03.062-.067v-.063c0-.022-.004-.043-.013-.063l-.327-.628c-.024-.055-.076-.089-.134-.089h-.581c-.094 0-.11.007-.11.114z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.485 3.168c.32 0 .579.26.579.581 0 .322-.259.582-.579.582-.319 0-.578-.261-.578-.582s.259-.581.578-.581zm0 .786c.113 0 .204-.091.204-.205 0-.112-.091-.204-.204-.204-.112 0-.203.091-.203.204 0 .114.091.205.203.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.718 3.168c.32 0 .579.26.579.581 0 .322-.259.582-.579.582s-.579-.261-.579-.582.26-.581.579-.581zm0 .786c.112 0 .204-.091.204-.205 0-.112-.091-.204-.204-.204-.112 0-.203.091-.203.204 0 .114.091.205.203.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.413 3.172c.32 0 .579.26.579.582 0 .321-.259.581-.579.581-.319 0-.578-.26-.578-.581 0-.322.259-.582.578-.582zm0 .786c.113 0 .204-.091.204-.204s-.091-.205-.204-.205c-.112 0-.203.091-.203.205 0 .112.091.204.203.204z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.601 1.317c0-.528-.428-.957-.956-.957h-1.449c-.528 0-.956.429-.956.957 0 .527.428.956.956.956h1.449c.528 0 .956-.429.956-.956z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckPlain);
export default __webpack_public_path__ + "static/media/truck-plain.32af5ae98c86b924edf771608db77108.svg";
export { ForwardRef as ReactComponent };